import React, { useState } from "react";
import "../styles/ContactUs.css";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaInstagram,
  FaTwitter,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";

import { collection, addDoc, Timestamp } from "firebase/firestore";
import { db } from "../firebase";

export default function ContactUs() {
  const [form, setForm] = useState({
    name: "",
    contact: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");

    try {
      /* 🔥 SAVE TO FIRESTORE */
      await addDoc(collection(db, "contactMessages"), {
        name: form.name,
        contact: form.contact,
        email: form.email,
        message: form.message,
        createdAt: Timestamp.now(),
      });

      setStatus("sent");
      setForm({ name: "", contact: "", email: "", message: "" });

      setTimeout(() => setStatus(""), 3000);
    } catch (error) {
      console.error("Submission error:", error);
      setStatus("error");
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-wrapper">

        {/* LEFT – CONTACT INFO */}
        <div className="contact-info-card">
          <h2>Contact Us</h2>

          <div className="info-item">
            <FaMapMarkerAlt />
            <p>
              15, Light House Road,<br />
              R. S. Puram,<br />
              Coimbatore – 641001,<br />
              Tamil Nadu
            </p>
          </div>

          <div className="info-item">
            <FaEnvelope />
            <p>info@sproutks.com</p>
          </div>

          <div className="info-item">
            <FaPhoneAlt />
            <p>+91 96771 12550</p>
            <p>+91 96771 12551</p>
          </div>

          <div className="social-icons">
            <a
              href="https://www.instagram.com/sproutks.official?igsh=M3Vyc3JvcHpjcTJs"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>

            <a
              href="https://x.com/sproutks"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <FaTwitter />
            </a>

            <a
              href="https://www.facebook.com/profile.php?id=61578866370856"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>

            <a
              href="https://www.linkedin.com/company/sproutknowledge/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>

        {/* RIGHT – CONTACT FORM */}
        <div className="contact-form-card">
          <h2>Get in Touch</h2>
          <p className="subtext">We’d love to hear from you</p>

          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your full name"
              value={form.name}
              onChange={handleChange}
              required
            />

            <input
              type="tel"
              name="contact"
              placeholder="Your contact number"
              value={form.contact}
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="email"
              placeholder="name@example.com"
              value={form.email}
              onChange={handleChange}
              required
            />

            <textarea
              name="message"
              placeholder="Tell us about your project or enquiry"
              rows="5"
              value={form.message}
              onChange={handleChange}
            />

            <button type="submit" disabled={status === "sending"}>
              {status === "sending" ? "Sending..." : "Send message"}
            </button>

            {status === "sent" && (
              <span className="success-msg">
                ✅ Message sent successfully
              </span>
            )}

            {status === "error" && (
              <span className="error-msg">
                ❌ Something went wrong. Please try again.
              </span>
            )}
          </form>
        </div>

      </div>
    </div>
  );
}